export default __webpack_public_path__ + "static/media/Icon menu My Numbers _ Inactive.6fd29005.svg";